import { z } from 'zod'

export const createPodoUserResponseSchema = z.object({
  userInfo: z.object({
    id: z.string().describe('User ID'),
    name: z.string().describe('Name'),
    phone: z.string().describe('Phone number'),
    email: z.string().describe('Email'),
    classType: z.string().describe('Class type'),
    langType: z.string().describe('Language type'),
    accessToken: z.string().describe('User token'),
    trialPaymentYn: z.string().describe('Whether a trial lesson was purchased'),
    trialClassCompYn: z.string().describe('Whether the trial lesson was completed'),
    paymentYn: z.string().describe('Whether a regular lesson product was purchased'),
    trialPaymentInfo: z.string().describe('Trial lesson purchase information'),
    trialClassCompInfo: z.string().describe('Trial lesson completion information'),
    paymentInfo: z.string().describe('Regular lesson purchase information'),
    remainTicketCount: z.string().describe('Remaining lesson ticket count'),
    regClassCount: z.string().describe('Reserved lesson count'),
    isUnlimitedTicket: z.string().describe('Whether the user has an unlimited lesson ticket'),
    companyUserId: z.string().describe('External user ID for Lemonboard registration checks'),
  }),
  registered: z.boolean().describe('Registration status'),
  userid: z.string().describe('User ID'),
  USER_TYPE: z.string().describe('User type'),
  USER_TOKEN: z.string().describe('User token'),
  resultCd: z.string().describe('Result code'),
})

export const updateDeviceTokenResponseSchema = z.object({
  resultCd: z.string().describe('Result code'),
  resultCdName: z.string().describe('Result code name'),
  message: z.string().describe('Message'),
  data: z.boolean().describe('Data'),
})

export type CreatePodoUserResponse = z.infer<typeof createPodoUserResponseSchema>
export type UpdateDeviceTokenResponse = z.infer<typeof updateDeviceTokenResponseSchema>
